import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/plan/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/task_immediate/detail', Object.assign({}, options, { params }))

// 删除任务
export const removePlan = (params, options) =>
request.post('/api/v4ward/plan/remove', qs.stringify(params),options);

// 关闭任务
export const closePlan = (params, options) =>
request.post('/api/v4ward/plan/close', params,options)
// 计划编辑
export const updatePlan = (params, options) =>
request.post('/api/v4ward/plan/update', params,options)

// 获取项目列表
export const getProjectList = (params, options) =>
        request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

// 获取系统字典
export const getDictionary = (code, options) =>
        request.get('/api/blade-system/dict/dictionary?code=' + code, Object.assign({}, options, {}));


 //获取项目字典
export const getBisDictData = (params, options) =>
request.get('/api/v4ward/projectDict/dictionary', Object.assign({}, options, { params }));

// 新增计划
export const addPlan = (params, options) =>
        request.post('/api/v4ward/plan/add', params,options)

// 搜索设备接口
export const standardUpkeepDevice = (params, options) =>
request.get('/api/device/pageWithStandard', Object.assign({}, options, { params }));


// 根据项目id、工单类型,工单子类型获取该班组成员
export const getGroupListForOrder = (params, options) =>
request.get('/api/v4ward/group/getGroupListForOrder', Object.assign({}, options, { params }));

// 根据任务类型获取工单类型
export const getOrderType = (params, options) =>
request.get('/api/v4ward/taskordertype/getOrderType', Object.assign({}, options, { params }));

// 计划详情
export const getPlanDetail = (params, options) =>
request.get('/api/v4ward/plan/detail', Object.assign({}, options, { params }));

// 调整详情 /adjustDetail
export const adjustDetail = (params, options) =>
request.get('/api/v4ward/task/adjustDetail', Object.assign({}, options, { params }));

// 设备维保任务明细详情
export const upkeepDetail = (params, options) =>
request.get('/api/upkeeptasklist/upkeepDetail', Object.assign({}, options, { params }));

// 设备巡检任务明细详情(url冲突，使用的时候去掉“1”)
export const deviceinspecttasklist = (params, options) =>
request.get('/api/deviceinspecttasklist/taskDetail', Object.assign({}, options, { params }));

// 添加全部设备
export const listWithStandard = (params, options) =>
request.get('/api/device/listWithStandard', Object.assign({}, options, { params }));



//获取标准根据工单子类
export const getStandardName = (params, options) =>
request.get('/api/v4ward/general/inspect/getStandardName', Object.assign({}, options, { params }));